// extracted by mini-css-extract-plugin
export default {"headDiv":"SuccessNotification_headDiv__AIeyc","successNotification":"SuccessNotification_successNotification__Ncjfs"};